export enum RegistryAddressTypeEnum {
  LEGALE = "LEGALE",
  LEGALE_PRINCIPALE = "LEGALE PRINCIPALE",
  RESIDENZA = "RESIDENZA",
  RESIDENZA_PRINCIPALE = "RESIDENZA PRINCIPALE",
}